const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-TextArea',
			DefaultInputExtensions: [ 'TextAreaProvider', 'InputValidation' ],
			Template: /*HTML*/`
			<!-- InputType TextArea {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control control-status">
						<span class="control-status-icon"></span>
						<textarea
							id="{~D:Record.Macro.RawHTMLID~}"
							class="textarea"
							{~D:Record.Macro.ControlAttr~}
							placeholder="{~Placeholder:Record~}"
							rows="2"
							{~Required:Record~}
							{~Disabled:Record~}
							{~D:Record.Macro.InputFullProperties~}
							{~D:Record.Macro.InputChangeHandler~}
						></textarea>
					</p>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-TextArea',
			DefaultInputExtensions: [ 'TextAreaProvider', 'InputValidation' ],
			Template: /*HTML*/`
				<!-- InputType TextArea {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="pict-form-vertical-input column pb-3">
					<div class="columns is-mobile is-vcentered">
						<div class="column">
							<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
						</div>
						<div class="column description-text">{~D:Record.Description~}</div>
						<div class="column">
							<div class="field">
								<p class="control control-status">
									<span class="control-status-icon"></span>
									<textarea
										id="{~D:Record.Macro.RawHTMLID~}"
										class="textarea"
										{~D:Record.Macro.ControlAttr~}
										placeholder="{~Placeholder:Record~}"
										rows="2"
										{~Required:Record~}
										{~Disabled:Record~}
										{~D:Record.Macro.InputFullProperties~}
										{~D:Record.Macro.InputChangeHandler~}
									></textarea>
								</p>
							</div>
						</div>
					</div>
				</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-TextArea',
			DefaultInputExtensions: [ 'TextAreaProvider', 'InputValidation' ],
			Template: /*HTML-Partial*/`
			<!-- InputType TextArea {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field mb-0">
				<p class="control control-status">
					<span class="control-status-icon"></span>
					<textarea
						id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						class="textarea"
						{~D:Record.Macro.ControlAttr~}
						{~Required:Record~}
						{~Disabled:Record~}
						placeholder="{~Placeholder:Record~}"
						rows="2"
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-TextArea',
			Template: /*HTML-Partial*/`
					></textarea>
				</p>
			</div>
			<p class="help"></p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-TextArea',
			DefaultInputExtensions: [ 'TextAreaProvider' ],
			Template: /*HTML*/`
			<!-- InputType TextArea {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control">
						<textarea
							id="{~D:Record.Macro.RawHTMLID~}"
							class="textarea"
							{~D:Record.Macro.ControlAttr~}
							rows="2"
							{~D:Record.Macro.InputFullProperties~}
							readonly aria-readonly="true"
						></textarea>
					</p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-TextArea',
			DefaultInputExtensions: [ 'TextAreaProvider' ],
			Template: /*HTML*/`
			<!-- InputType TextArea {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<p class="control">
								<textarea
									id="{~D:Record.Macro.RawHTMLID~}"
									class="textarea"
									{~D:Record.Macro.ControlAttr~}
									rows="2"
									{~D:Record.Macro.InputFullProperties~}
									readonly aria-readonly="true"
								></textarea>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-TextArea',
			DefaultInputExtensions: [ 'TextAreaProvider' ],
			Template: /*HTML-Partial*/`
			<!-- InputType TextArea {~D:Record.Hash~} {~D:Record.DataType~} -->
			<textarea
				id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				class="textarea"
				{~D:Record.Macro.ControlAttr~}
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~}
				rows="2"
				readonly aria-readonly="true"`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-TextArea',
			Template: /*HTML-Partial*/`
			></textarea>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-TextArea',
			Template: /*HTML*/`
			<!-- InputType TextArea {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div
							id="{~D:Record.Macro.RawHTMLID~}"
							class="textarea is-static"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
						></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-TextArea',
			Template: /*HTML*/`
			<!-- InputType TextArea {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="control">
							<div
								id="{~D:Record.Macro.RawHTMLID~}"
								class="textarea is-static"
								{~D:Record.Macro.ControlAttr~}
								{~D:Record.Macro.InputFullProperties~}
							></div>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-TextArea',
			Template: /*HTML-Partial*/`
			<!-- InputType TextArea {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div
				id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				class="textarea is-static"
				{~D:Record.Macro.ControlAttr~}
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-TextArea',
			Template: /*HTML-Partial*/`
			></div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;
